import { Hint } from '@systemeio/ui'
import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { ListIcon } from '@systemeio/ui/icons'
import { twMerge } from 'tailwind-merge'

type Props = {
  additionalChild?: ReactNode
  disabled?: boolean
}

const ResourcesBase: FC<PropsWithChildren<Props>> = ({ additionalChild, children, disabled }) => {
  const { t } = useLocoTranslation()
  return (
    <div className="flex flex-col gap-3 lg:gap-2">
      <div className="flex flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-0">
        <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3">
          <div className="text-text-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">
            <ListIcon className={'fill-text-primary h-6 w-6 scale-75'} />
            <Hint
              label={t('dashboard.funnel.configuration.common.offer_resources.description_popover')}
            >
              {t('dashboard.funnel.configuration.common.offer_resources.title')}
            </Hint>
          </div>
        </div>
        {additionalChild}
      </div>
      <div
        className={twMerge(
          'flex flex-col gap-3 lg:gap-2',
          disabled && 'pointer-events-none opacity-50',
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default ResourcesBase
